// Ορολογία BBQ ανά μαγαζί (8/8/2026): κάποια μαγαζιά ψήνουν κρέατα, άλλα ψάρια.
// Η ρύθμιση company_settings.bbq_item_kind ('meat'|'fish'|'mixed') προσαρμόζει
// εικονίδια και λεκτικά, μέσα από τα cached app settings (utils/appSettings).
import i18n from '../i18n';

const KEY = 'app_settings';

export function bbqKind() {
  try {
    const s = JSON.parse(localStorage.getItem(KEY)) || {};
    return ['meat', 'fish', 'mixed'].includes(s.bbq_item_kind) ? s.bbq_item_kind : 'meat';
  } catch {
    return 'meat';
  }
}

export function bbqIcon() {
  const k = bbqKind();
  return k === 'fish' ? '🐟' : k === 'mixed' ? '🍢' : '🍖';
}

// Μετάφραση όρου με προσαρμογή στο είδος: bbqTerm('Manage Meats') → «Διαχείριση Ψαριών»
// όταν kind=fish. Τα fish/mixed variants είναι κανονικά i18n keys ("<key> [fish]" κ.λπ.).
export function bbqTerm(key, opts) {
  const k = bbqKind();
  if (k === 'meat') return i18n.t(key, opts);
  const variant = `${key} [${k}]`;
  const out = i18n.t(variant, opts);
  return out === variant ? i18n.t(key, opts) : out; // fallback στο βασικό αν λείπει variant
}
